export enum UsersOrganizationsPermissionsReadType{
    IsOwner = 1,
    ClosedParties = 2,
}
